module.exports = __webpack_public_path__ + "static/patient3_mobile-b01d720eed4dfc48490bc3d839339f0f.jpg";